//BB: Overall performsnce reducer 


import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface AiFeedbackPoint {
    courses_analytics: any[];
    filters_applied: any;
    overall_avg_score: any;
    new_overall_avg_score_of_allcourses: any;
    avg_score: any;
    status: any
}

const initialState: AiFeedbackPoint = {
    courses_analytics: [],
    filters_applied: {},
    overall_avg_score: null,
    new_overall_avg_score_of_allcourses: null,
    avg_score: null,
    status: null

};


const aiFeedbackPointByTeacherSlice = createSlice({
    name: "aiFeedbackPointByTeacher",
    initialState,
    reducers: {

        
        setPointData: (state, action: PayloadAction<{ courses_analytics: any[], filters_applied: any, overall_avg_score: any, new_overall_avg_score_of_allcourses:any, avg_score:any, status:any}>) => {
            const { courses_analytics, filters_applied, overall_avg_score, new_overall_avg_score_of_allcourses, avg_score, status } = action.payload;
            state.courses_analytics = courses_analytics;
            state.filters_applied = filters_applied;
            state.overall_avg_score = overall_avg_score;
            state.new_overall_avg_score_of_allcourses = new_overall_avg_score_of_allcourses;
            state.avg_score = avg_score;
            state.status = status;
        },
        resetPointData: (state) => {
            // Reset state back to its initial state
            state.courses_analytics = [];
            state.filters_applied = {};
            state.overall_avg_score = null;
            state.new_overall_avg_score_of_allcourses = null;
            state.avg_score = null;
            state.status = null;
        },
        // setPagination: (state: CourseState, action: PayloadAction<CourseState>) => {
        //     state.next = action.payload.next;
        //     state.previous = action.payload.previous;
        //     state.count = action.payload.count;
        //     state.totalPages = Math.ceil((action.payload.count ?? 0) / 12);
        //     state.isLoading = false;
        //     state.error = null;
        // },
        // setloading: (state: CourseState, action: PayloadAction<boolean>) => {
        //     state.isLoading = action.payload;
        //     state.error = null;
        // },
        // seterror: (state: CourseState, action: PayloadAction<string>) => {
        //     state.error = action.payload;
        //     state.isLoading = false;
        // },
        resetCourseList: () => {
            return initialState;
        },
    },
});

export const {
     setPointData,
     resetPointData,
    // setloading,
    // seterror,
    // setPagination,
    resetCourseList,
} = aiFeedbackPointByTeacherSlice.actions;

export default aiFeedbackPointByTeacherSlice.reducer;
